import { render, staticRenderFns } from "./KO.vue?vue&type=template&id=387fa7dc&scoped=true&"
import script from "./KO.vue?vue&type=script&lang=js&"
export * from "./KO.vue?vue&type=script&lang=js&"
import style0 from "./KO.vue?vue&type=style&index=0&id=387fa7dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387fa7dc",
  null
  
)

export default component.exports